import {useForm} from "@mantine/form";
import {
    FormConsigneeInformationFormValues,
    formConsigneeInformationInitialValues
} from "./Form.consignee.information.types";
import {Button, Divider, Grid, Group, Select, Stack, TextInput, Title} from "@mantine/core";
import MantineForm from "../../../common/Mantine.form";
import {ArrowRight} from "tabler-icons-react";
import React from "react";
import {IUser} from "../../../../api/User/User.types";

interface Props {
    onSubmit?: (values: any) => void
    buttons?: any,
    initialValues?: any,
    user:IUser,
}

function ConsigneeInformation({onSubmit, buttons, initialValues, user}: Props) {

    const form = useForm({
        initialValues: initialValues || formConsigneeInformationInitialValues
    });

    function handleSubmit(values: any) {
        if (onSubmit) {
            onSubmit(values)
        }
    }

    function renderButtons() {
        if (buttons) {
            return buttons;
        } else {
            return (
                <Group position="right" mt="xl" align="flex-end">
                    <Button color="blue" type="submit" rightIcon={<ArrowRight/>}>
                        Next
                    </Button>
                </Group>
            )
        }
    }

    if (!user?.consignees) {
        return <div>No consignees found</div>
    }

    function onConsigneeChange(consigneeId: any) {
        let selectedConsignee = user!.consignees!.find(sh => sh.entityID === consigneeId);

        form.getInputProps(FormConsigneeInformationFormValues.consigneeId).onChange(consigneeId);

        if (selectedConsignee) {

            form.setFieldValue(FormConsigneeInformationFormValues.consigneeEmail, selectedConsignee.email);
            form.setFieldValue(FormConsigneeInformationFormValues.consigneePhone, selectedConsignee.phone);
            form.setFieldValue(FormConsigneeInformationFormValues.consigneeFax, selectedConsignee.fax);
            form.setFieldValue(FormConsigneeInformationFormValues.consigneeTaxId, selectedConsignee.taxId);
            form.setFieldValue(FormConsigneeInformationFormValues.consigneeId, selectedConsignee.entityID);
            form.setFieldValue(FormConsigneeInformationFormValues.consigneeName, selectedConsignee.entityName);

            Object.keys(selectedConsignee.address).forEach(field => {
                form.setFieldValue(field, selectedConsignee!.address[field]);
            })
        }
    }

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
                <Title order={3}>Consignee Information</Title>
                <Divider/>
                <Grid>
                    <Grid.Col md={12}>
                        <Select
                            data={user?.consignees?.map(sh => ({value: sh.entityID, label: sh.entityName}))}
                            required
                            placeholder="Consignee Name"
                            label="Name"
                            {...form.getInputProps(FormConsigneeInformationFormValues.consigneeId)}
                            onChange={onConsigneeChange}
                        />
                    </Grid.Col>
                    {form.values[FormConsigneeInformationFormValues.consigneeId] &&
                        <>
                            <Grid.Col md={12}>
                                <TextInput
                                    disabled
                                    placeholder="AGL ID"
                                    label="AGL ID"
                                    {...form.getInputProps(FormConsigneeInformationFormValues.consigneeId)}
                                />
                            </Grid.Col>
                            <Grid.Col md={12}>
                                <TextInput
                                    disabled
                                    required
                                    placeholder="Consignee Email"
                                    label="Email"
                                    {...form.getInputProps(FormConsigneeInformationFormValues.consigneeEmail)}
                                />
                            </Grid.Col>
                            <Grid.Col md={6}>
                                <TextInput
                                    disabled
                                    required
                                    placeholder="Consignee Phone"
                                    label="Phone"
                                    {...form.getInputProps(FormConsigneeInformationFormValues.consigneePhone)}
                                />
                            </Grid.Col>
                            <Grid.Col md={6}>
                                <TextInput
                                    disabled
                                    required
                                    placeholder="Consignee Fax"
                                    label="Fax"
                                    {...form.getInputProps(FormConsigneeInformationFormValues.consigneeFax)}
                                />
                            </Grid.Col>
                            <Grid.Col md={12}>
                                <TextInput
                                    disabled
                                    required
                                    placeholder="Consignee Tax ID"
                                    label="Tax ID"
                                    {...form.getInputProps(FormConsigneeInformationFormValues.consigneeTaxId)}
                                />
                            </Grid.Col>
                            <Grid.Col span={12}>
                                <MantineForm.Address form={form} disableAllFields/>
                            </Grid.Col>
                        </>
                    }
                </Grid>
                {renderButtons()}
            </Stack>
        </form>
    )

}

export default ConsigneeInformation;